import { isValidIncrement } from "utils/currency";
import "./index.scss";
import { isValidNumberWithinBoundary } from "utils/numbers";
import { useCallback, useState } from "react";

export const BrandCashInputRange = ({
  value,
  selected,
  selectInput,
  onChange,
  increment,
  max_value,
  min_value
}) => {
  const [focus, setFocus] = useState(false);
  const [error, setError] = useState(null);

  const centsMultiplier = 0.01;
  const decimalPattern = /^\d+(?:\.\d{1,2})?$/;

  const focusInput = useCallback(() => {
    setFocus(true);
    selectInput();
  }, [selectInput]);

  const handleInputKeyDown = useCallback(
    (event) => {
      if (event.key === "Enter" || event.key === "NumpadEnter") focusInput();
    },
    [focusInput]
  );

  const handleInputChange = useCallback(
    (event) => {
      focusInput();

      const { value: stringValue } = event.target;
      const value = stringValue.replace(/\$/g, "");
      const isDecimal = value.indexOf(".") >= 0;
      const trimmedValue = isDecimal
        ? value.slice(0, value.indexOf(".") + 3)
        : value;

      const shouldDisplayError =
        trimmedValue.length &&
        (!isValidIncrement({ increment, value: trimmedValue }) ||
          !isValidNumberWithinBoundary(trimmedValue, {
            min: min_value * centsMultiplier,
            max: max_value * centsMultiplier
          }));

      setError(shouldDisplayError);
      onChange(trimmedValue);
    },
    [increment, max_value, min_value, onChange, focusInput]
  );

  const isFocusedOrEmpty = focus || !value;

  return (
    <div
      className={`brand-cash-input-range amount-item amount-range${
        selected ? " selected" : ""
      }${error ? " error" : ""}`}
    >
      <input
        value={isFocusedOrEmpty ? value : `$${value}`}
        type={isFocusedOrEmpty ? "number" : "text"}
        onBlur={() => setFocus(false)}
        placeholder="$ Enter Exact Amount"
        onClick={focusInput}
        onChange={handleInputChange}
        onKeyDown={handleInputKeyDown}
        min={min_value * centsMultiplier}
        max={max_value * centsMultiplier}
        pattern={decimalPattern}
      />
      <span className="warning-message">
        Enter an amount between ${min_value * centsMultiplier} - $
        {max_value * centsMultiplier}.
      </span>
    </div>
  );
};
